import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import {
  frFR as french,
  enUS as english,
  trTR as Turkish,
  itIT as Italian,
  deDE as German,
  esES as spanish,
  arSD as Arabic,
  jaJP as Japanese,
} from "@mui/x-data-grid";

import {
  deDE,
  frFR,
  enUS,
  trTR,
  itIT,
  esES,
  jaJP,

} from "@mui/x-date-pickers/locales";

import frAnt from "antd/lib/locale/fr_FR"; // French locale
import enAnt from "antd/lib/locale/en_US"; // English locale
import esAnt from "antd/lib/locale/es_ES"; // Spanish locale
import itAnt from "antd/lib/locale/it_IT"; // Italian locale
import trAnt from "antd/lib/locale/tr_TR"; // Turkish locale
import deAnt from "antd/lib/locale/de_DE"; // Deutch locale
import arAnt from "antd/lib/locale/ar_EG"; // Arabic locale
import jaAnt from "antd/lib/locale/ja_JP"; // Arabic locale

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { TUser } from "../shared/types/user.type";
import i18n from "../locales";
import { setTempLang } from "../store/reducers/display.reducer";

export const useLocales = () => {
  const auth = useSelector<RootState>((state) => state.user.user) as TUser;
  const [currentLang, setCurrentLang] = useState(
    sessionStorage.getItem("tempLang") ?? auth?.lang ?? "en",
  );

  const dispatch = useDispatch();
  useEffect(() => {
    // PDF export pages (/pdf/*) carry an explicit ?lang= requested by the
    // PDF renderer — it takes precedence and is not persisted to
    // localStorage (headless browsers have no user preference anyway).
    const urlLang = window.location.pathname.startsWith("/pdf")
      ? new URLSearchParams(window.location.search).get("lang")?.toLowerCase()
      : null;

    if (urlLang) {
      setCurrentLang(urlLang);
      i18n.changeLanguage(urlLang);
      return;
    }

    const tempLang = sessionStorage.getItem("tempLang");
    let lang = tempLang || auth?.lang || localStorage.getItem("lang") || "en";

    updateLang(lang);
  }, [auth?.lang]);

  const getTimePickerLocales = () => {
    switch (currentLang) {
      case "fr":
        return frFR.components.MuiLocalizationProvider.defaultProps.localeText;
      case "en":
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
      case "it":
        return itIT.components.MuiLocalizationProvider.defaultProps.localeText;
      case "de":
        return deDE.components.MuiLocalizationProvider.defaultProps.localeText;
      case "tr":
        return trTR.components.MuiLocalizationProvider.defaultProps.localeText;
      case "es":
        return esES.components.MuiLocalizationProvider.defaultProps.localeText;
      case "ar":
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
      case "ja":
        return jaJP.components.MuiLocalizationProvider.defaultProps.localeText;
      default:
        return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
  };
  const getAntTimePickerLocales = () => {
    switch (currentLang) {
      case "fr":
        return frAnt;
      case "en":
        return enAnt;
      case "it":
        return itAnt;
      case "de":
        return deAnt;
      case "tr":
        return trAnt;
      case "es":
        return esAnt;
      case "ar":
        return arAnt;
      case "ja":
        return jaAnt;
      default:
        return enAnt;
    }
  };

  const getDataGridLocales = () => {
    switch (currentLang) {
      case "fr":
        return french.components.MuiDataGrid.defaultProps.localeText;
      case "en":
        return english.components.MuiDataGrid.defaultProps.localeText;
      case "it":
        return Italian.components.MuiDataGrid.defaultProps.localeText;
      case "de":
        return German.components.MuiDataGrid.defaultProps.localeText;
      case "tr":
        return Turkish.components.MuiDataGrid.defaultProps.localeText;
      case "es":
        return spanish.components.MuiDataGrid.defaultProps.localeText;
      case "ar":
        return Arabic.components.MuiDataGrid.defaultProps.localeText;
      case "ja":
        return Japanese.components.MuiDataGrid.defaultProps.localeText;
      default:
        return english.components.MuiDataGrid.defaultProps.localeText;
    }
  };

  const updateLang = (lang: string) => {
    setCurrentLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  const updateLangTemp = (lang: string, callback?: () => void) => {
    setCurrentLang(lang);
    sessionStorage.setItem("tempLang", lang);
    i18n.changeLanguage(lang).then(() => {
      callback?.();
    });
  };
  const updateTempLang = (lang: string | null) => {
    dispatch(setTempLang(lang));
  };
  return {
    currentLang,
    getDataGridLocales,
    getTimePickerLocales,
    getAntTimePickerLocales,
    updateLang,
    isRtl: currentLang === "ar",
    updateTempLang,
    updateLangTemp
  };
};
